import { useEffect, useRef } from 'react'

interface UseFashionEspecificacaoAutoFillArgs {
  productName: string | undefined
  value: string
  onChange: (value: string) => void
}

export const useFashionEspecificacaoAutoFill = ({
  productName, value, onChange,
}: UseFashionEspecificacaoAutoFillArgs) => {
  const lastAutoRef = useRef<string | null>(null)

  useEffect(() => {
    const auto = (productName ?? '').trim()
    const current = (value ?? '').trim()

    // Texto manual do vendedor vence: só escreve sobre vazio ou sobre o último auto-gerado.
    if (current !== '' && current !== lastAutoRef.current && current !== auto) return

    if (current !== auto) onChange(auto)
    lastAutoRef.current = auto
  }, [productName, value, onChange])
}
